export default __webpack_public_path__ + "static/media/tab1_moniter.cc95147f.svg";